<template>
  <div class="verify_page">
    <div class="content">
      <div class="card result-card">
        <div class="card-header">
          <i class="fas fa-barcode"></i>
          <h3>防伪查询结果</h3>
        </div>

        <div class="security-code">
          <p>您查询的防伪码:</p>
          <span class="code">{{ random }}</span>
        </div>

        <div class="verification-info warning" v-if="data && data.scan_times !== 1">
          <div class="info-header">
            <i class="fas fa-exclamation-triangle"></i>
            <h4>验证信息</h4>
          </div>
          <p>您好，您所查询的防伪码已被查询过！</p>
          <div class="details">
            <p><span>首次查询时间:</span> {{ data.scan_date }}</p>
            <p><span>查询次数:</span> 第{{ data.scan_times }}次查询</p>
          </div>
          <p class="warning-text">请确认，谨防假冒！</p>
        </div>
        <div class="verification-info warning" v-if="data && data.scan_times === 1">
          <div class="info-header">
            <i class="fas fa-exclamation-triangle"></i>
            <h4>验证信息</h4>
          </div>
          <p>您好，您所查询的防伪码是正品。</p>
        </div>
        <div class="verification-info warning" v-if="!data">
          <div class="info-header">
            <i class="fas fa-exclamation-triangle"></i>
            <h4>验证信息</h4>
          </div>
          <p>您好，查无信息(查无数据，无法保证此商品为正品)。</p>
        </div>
      </div>
    </div>

    <div class="footer">
      <p>顺科智洗二维码防伪查询系统</p>
    </div>
  </div>
</template>

<script>
  import Axios from 'axios';
  export default {
    name: 'VerifyPage',
    data() {
      return { data: null, random: '' };
    },
    methods: {
      getVerify(random) {
        let url = `https://backend.skzhixi.com/manage/open/v1/verify/random?random=${random}`;
        return Axios.get(url);
      },
    },
    beforeCreate() {
      document.title = '顺科智洗';
    },
    async mounted() {
      if (this.$route.query.random) {
        this.random = this.$route.query.random;
        try {
          const verifyRes = await this.getVerify(this.$route.query.random);
          this.data = verifyRes.data.data || null;
        } catch (error) {
          //
        }
      }
    },
  };
</script>

<style lang="scss" scoped>
  .verify_page {
    min-height: 100vh;
    padding: 12px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;

    .header {
      text-align: center;
      margin-bottom: 30px;

      .logo {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 15px;

        i {
          font-size: 32px;
          color: #3498db;
        }

        h2 {
          color: #2c3e50;
          font-weight: 600;
          margin: 0;
        }
      }
    }

    .content {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: flex-start;
    }

    .result-card {
      background: white;
      border-radius: 16px;
      box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
      padding: 12px;
      width: 100%;
      max-width: 500px;

      .card-header {
        display: flex;
        align-items: center;
        gap: 12px;
        margin-bottom: 25px;
        padding-bottom: 15px;
        border-bottom: 1px solid #eee;

        i {
          color: #3498db;
          font-size: 24px;
        }

        h3 {
          color: #2c3e50;
          margin: 0;
          font-size: 20px;
        }
      }
    }

    .security-code {
      margin-bottom: 25px;
      text-align: center;

      p {
        color: #7f8c8d;
        margin-bottom: 8px;
        font-size: 15px;
      }

      .code {
        display: inline-block;
        background: #f8f9fa;
        padding: 12px 20px;
        border-radius: 10px;
        font-family: monospace;
        font-size: 18px;
        font-weight: bold;
        letter-spacing: 1px;
        color: #2c3e50;
        border: 1px dashed #ddd;
      }
    }

    .verification-info {
      background: #fffbf0;
      border-left: 4px solid #f39c12;
      border-radius: 8px;
      padding: 12px;
      // margin-bottom: 25px;

      &.warning {
        background: #fef9f3;
        border-left-color: #e74c3c;
      }

      .info-header {
        display: flex;
        align-items: center;
        margin-bottom: 15px;

        i {
          color: #e74c3c;
          font-size: 20px;
        }

        h4 {
          color: #c0392b;
          margin: 0;
          font-size: 17px;
        }
      }

      p {
        color: #7f8c8d;
        line-height: 1.6;
        margin-bottom: 10px;
      }

      .details {
        background: rgba(255, 255, 255, 0.7);
        padding: 12px;
        border-radius: 8px;
        margin: 15px 0;

        p {
          margin-bottom: 8px;

          span {
            font-weight: 600;
            color: #34495e;
          }
        }
      }

      .warning-text {
        color: #e74c3c !important;
        font-weight: 600;
        margin-top: 10px;
      }
    }

    .qrcode-section {
      text-align: center;
      padding: 20px 0;
      border-top: 1px solid #eee;
      border-bottom: 1px solid #eee;
      margin-bottom: 25px;

      h4 {
        color: #2c3e50;
        margin-bottom: 8px;
      }

      p {
        color: #7f8c8d;
        margin-bottom: 20px;
        font-size: 14px;
      }

      .qrcode-placeholder {
        background: #f9f9f9;
        border: 1px dashed #ddd;
        border-radius: 12px;
        padding: 30px;
        width: 180px;
        height: 180px;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        i {
          font-size: 60px;
          color: #95a5a6;
          margin-bottom: 15px;
        }

        p {
          color: #7f8c8d;
          margin: 0;
          font-size: 13px;
        }
      }
    }

    .actions {
      display: flex;
      gap: 15px;

      .btn {
        flex: 1;
        padding: 14px;
        border-radius: 10px;
        border: none;
        font-weight: 600;
        font-size: 15px;
        cursor: pointer;
        transition: all 0.3s;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;

        &.primary {
          background: #3498db;
          color: white;

          &:hover {
            background: #2980b9;
          }
        }

        &.secondary {
          background: #ecf0f1;
          color: #7f8c8d;

          &:hover {
            background: #dfe6e9;
          }
        }
      }
    }

    .footer {
      text-align: center;
      margin-top: 40px;

      p {
        color: #7f8c8d;
        font-size: 13px;
      }
    }

    @media (max-width: 600px) {
      padding: 15px;

      .result-card {
        padding: 12px;
      }

      .actions {
        flex-direction: column;
      }

      .qrcode-placeholder {
        width: 150px !important;
        height: 150px !important;

        i {
          font-size: 50px !important;
        }
      }
    }
  }
</style>
